<template>
	<CRichText :data="data" />
</template>

<script setup>
import CRichText from './CRichText.vue';
defineProps({
	data: {
		type: String,
		default: ''
	}
});
</script>

<style lang="less" scoped></style>
